export class RouteUrlConstants {

    public static readonly USER_ROUTE_URL = '/user';

    public static readonly CREATE_USER ="/user";

    public static readonly BULK_UPLOAD ="/user/user-config/user-manage/bulk-upload/user-upload";

    public static readonly BULK_UPLOAD_HISTORY ="/user/user-config/user-manage/bulk-upload/upload-history";

    public static readonly EDIT_USER ="/main/user-management/user-edit/";

    public static readonly VIEW_USER ="/main/user-management/user-view/";

    public static readonly EDIT_ROLE ="/main/user-management/role-edit/";

    public static readonly FORBIDDEN ="/user/forbidden";

    public static readonly FORCE_CHANGE_CREDENTIAL_ROUTE = ['change', 'password'].join('');

    public static readonly UPDATE_CREDENTIAL_ENDPOINT = ['/api/user/force-update', '-password'].join('');

    public static readonly LOGIN='/login';

}
